module.exports = __webpack_public_path__ + "2ae94b231cf41326f843d9c4445c8271.MP3";